import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[appLowercaseInput]',
    standalone: true
})
export class LowercaseInputDirective {

    constructor(private control: NgControl) {}

    @HostListener('input', ['$event'])
    @HostListener('change', ['$event'])
    onInput(event: Event): void {
        const input = event.target as HTMLInputElement;
        const lower = input.value.toLowerCase();
        if (input.value !== lower) {
            this.control.control?.setValue(lower);
        }
    }
}
